<style lang="less" scoped>
  @import "../../../vars.less";

  .container {
    padding: @space-normal;
    background-color: #fff;
  }
  .section {
    font-size: 14px;
    &:not(:first-child) {
      padding-top: @space-medium;
    }
    &:not(:last-child) {
      padding-bottom: @space-medium;
    }
  }
  .secondary {
    color: @text-color-secondary;
  }
  .title {
    margin: 0 0 @space-medium 0;
    font-size: 16px;
    color: @primary-color;
    font-weight: 500;
  }
  .item {
    margin: 0 0 8px 0;
    line-height: 24px;
  }
  .label {
    color: @text-color-secondary;
    &:after {
      content: ':';
      margin-right: @space-small;
    }
  }
  .value {
    color: @text-color;
  }
  .button-container {
    padding: @space-normal;
    background-color: #fff;
  }
  .track-item-title {
    color: @primary-color;
  }
  .track-item-title,
  .track-item-time {
    margin: 0
  }
  .track-item-time {
    font-style: italic;
  }
  .track-info {
    float: right;
  }
  .track-item {
    color: @text-color-secondary;
  }
</style>

<template>
  <page-container
    :title="$t('物流详情')"
    class="logistics-query-result" :loading="loading">
    <div class="container">
      <div class="section van-hairline--bottom">
        <h3 class="title">
          {{ $t('发货单号') }}: {{ logistics.DeliveryNumber }}
        </h3>
        <p class="item">
          <span class="label">{{ $t('发货单创建日期') }}</span>
          <span class="value">{{ logistics.delivery_create_date }}</span>
        </p>
        <p class="item">
          <span class="label">{{ $t('完成发货日期') }}</span>
          <span class="value">{{ logistics.pgi_date }}</span>
        </p>
      </div>
      <div class="section van-hairline--bottom">
        <h3 class="title">
          {{ $t('承运商信息') }}
        </h3>
        <p class="item">
          <span class="label">{{ $t('承运商') }}</span>
          <span class="value">{{ logistics.ForwarderName }}</span>
        </p>
        <p class="item">
          <span class="label">{{ $t('联系人') }}</span>
          <span class="value">{{ logistics.ContactName }}</span>
        </p>
        <p class="item">
          <span class="label">{{ $t('联系电话') }}</span>
          <span class="value">{{ logistics.ContactPhone }}</span>
        </p>
        <p class="item">
          <span class="label">{{ $t('电子邮件') }}</span>
          <span class="value">{{ logistics.ContactPhone }}</span>
        </p>
        <p class="item">
          <span class="label">{{ $t('运输方式') }}</span>
          <span class="value">{{ logistics.TransporModel }}</span>
        </p>
      </div>
      <div class="section">
        <h3 class="title">
          {{ $t('货物信息') }}
        </h3>
        <p class="item">
          <span class="label">{{ $t('城市') }}</span>
          <span class="value">{{ logistics.City }}</span>
        </p>
        <p class="item">
          <span class="label">{{ $t('收货地址') }}</span>
          <span class="value">{{ logistics.Consignee_Adress }}</span>
        </p>
        <p class="item">
          <span class="label">{{ $t('货物重量(KG)') }}</span>
          <span class="value">{{ logistics.Weight }}</span>
        </p>
        <p class="item">
          <span class="label">{{ $t('货物体积(M3)') }}</span>
          <span class="value">{{ logistics.Volume }}</span>
        </p>
        <p class="item">
          <span class="label">{{ $t('备注') }}</span>
          <span class="value">{{ logistics.Remark }}</span>
        </p>
      </div>
      <modal v-model="showModal" :title="$t('物流追踪') ">
        <van-cell v-if="logistics.delivery_create_date">
          <div class="track-item">
            <p class="track-item-title">L300 <span class="track-info">{{ $t('生成西门子订单号') }}</span></p>
            <p class="track-item-time">{{ logistics.delivery_create_date }}</p>
          </div>
        </van-cell>
        <van-cell v-if="logistics.pgi_date" >
          <div class="track-item">
            <p class="track-item-title">L310 <span class="track-info">{{ $t('货物待交承运人') }}</span></p>
            <p class="track-item-time">{{ logistics.pgi_date }}</p>
          </div>
        </van-cell>
        <van-cell v-if="logistics.ActualDeliveryDate">
          <div class="track-item">
            <p class="track-item-title">L311 <span class="track-info">{{ $t('承运人提货') }}</span></p>
            <p class="track-item-time">{{ logistics.ActualDeliveryDate }}</p>
          </div>
        </van-cell>
        <van-cell v-if="logistics.ActualArrivalDate">
          <div class="track-item">
            <p class="track-item-title">L400 <span class="track-info">{{ $t('派送完成') }}</span></p>
            <p class="track-item-time">{{ logistics.ActualArrivalDate }}</p>
          </div>
        </van-cell>
      </modal>
    </div>
    <div v-if="Object.keys(logistics).length" class="button-container" slot="footer">
      <van-button round block
        type="info" size="small"
        @click="() => showModal = true">{{ $t('物流追踪') }}</van-button>
    </div>
  </page-container>
</template>

<script>
import { Button, Cell, Toast } from 'vant'
import PageContainer from '../../../components/PageContainer'
import Modal from '../../../components/Modal'

export default {
  name: 'logistics-query-result',
  components: {
    'van-button': Button,
    'van-cell': Cell,
    PageContainer,
    Modal
  },
  data () {
    return {
      showModal: false,
      logistics: {},
      loading: false
    }
  },
  methods: {
    getLogistics () {
      this.$apis.order.getLogistics(
        this.$route.query.deliveryNumber,
        loading => (this.loading = loading)
      ).then(res => {
        this.logistics = res || {}
        if (!res) {
          Toast(this.$t('未找到相关物流信息'))
          // this.$router.back()
        }
      })
    }
  },
  mounted () {
    this.getLogistics()
  }
}
</script>
